import { Reveal } from "./Reveal";

export function SectionHeading({
  eyebrow,
  title,
  sub,
  align = "center",
  light = false,
}: {
  eyebrow?: string;
  title: React.ReactNode;
  sub?: React.ReactNode;
  align?: "center" | "left";
  light?: boolean;
}) {
  const alignCls = align === "center" ? "mx-auto text-center" : "text-left";
  return (
    <div className={`max-w-3xl ${alignCls}`}>
      {eyebrow && (
        <Reveal>
          <span
            className={`sticker -rotate-2 ${light ? "!border-white/90 !shadow-pop-white" : ""}`}
          >
            {eyebrow}
          </span>
        </Reveal>
      )}
      <Reveal delay={1}>
        <h2
          className={`display mt-6 text-4xl leading-[1.04] sm:text-5xl lg:text-6xl ${
            light ? "text-white" : "text-navy"
          }`}
        >
          {title}
        </h2>
      </Reveal>
      {sub && (
        <Reveal delay={2}>
          <p
            className={`mt-5 text-base leading-relaxed sm:text-lg ${
              light ? "text-white/90" : "text-charcoal/75"
            }`}
          >
            {sub}
          </p>
        </Reveal>
      )}
    </div>
  );
}
